import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Img} from '@salesforce/retail-react-app/app/components/shared/ui'
import {cloudinary} from '../utils/default'
import {updateTrackingParam} from '../utils/imageSrcset'

const CloudinaryPlpImage = ({cloudinaryImage = {}, image = {}, title}) => {
    if (typeof window !== 'undefined' && cloudinaryImage.url) {
        useEffect(() => {
            const replacedUrl = cloudinaryImage.url.replace('w_auto,c_scale', 'w_auto,c_limit')
            cloudinaryImage.url = replacedUrl
        }, [])
    }
    return (
        <Img
            data-testid="cloudinary-plp-img"
            className={cloudinaryImage?.isResponsive && 'cld-responsive'}
            src={`${
                cloudinaryImage.url.lastIndexOf('?') > -1
                    ? cloudinaryImage.url.substring(0, cloudinaryImage.url.lastIndexOf('?')) +
                      cloudinary.CLD_TRACKING_PARAM
                    : cloudinaryImage.url + cloudinary.CLD_TRACKING_PARAM
            }`}
            alt={image?.alt}
            title={title}
            width={290}
            height={290}
            style={{aspectRatio: '1/1'}}
            srcSet={
                !cloudinaryImage?.isResponsive &&
                cloudinaryImage.srcset &&
                updateTrackingParam(cloudinaryImage.srcset)
            }
            sizes={!cloudinaryImage?.isResponsive && cloudinaryImage?.sizes}
            sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain'
            }}
        />
    )
}

CloudinaryPlpImage.propTypes = {
    cloudinaryImage: PropTypes.object,
    dynamicImageProps: PropTypes.object,
    image: PropTypes.object,
    title: PropTypes.string
}

export default CloudinaryPlpImage
